module.exports = __webpack_public_path__ + "img/logo-p2.cc2b661f.webp";